<div class="iot-platform-ui-filter-engine pl-4 pr-4" data-cy="iot-platform-ui-filter-engine">
  <div class="iot-platform-ui-filter-engine__content" fxLayout="column">
    <mat-expansion-panel [expanded]="expanded()">
      <!-- Filter Builder -->
      <div class="iot-platform-ui-filter-engine__builder pt-4" [ngClass]="{ 'pb-4': !visibleFiltersCount() }" fxLayout="column" fxLayoutGap="12px">
        <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="start center" fxLayoutGap="10px">
          <div fxLayout="row" fxLayoutAlign.lt-sm="space-between" [ngStyle.lt-sm]="{ width: '100%' }" fxLayoutGap="10px">
            @if (withFavoriteFilters()) {
              <!-- Mode Toggle Button Group -->
              <div class="iot-platform-ui-filter-engine__type-toggle" fxLayout="row" fxLayoutAlign="start center">
                <mat-button-toggle-group [(ngModel)]="filterMode" [hideSingleSelectionIndicator]="true">
                  <mat-button-toggle
                    [matTooltip]="'IOT_TOOLBAR.TOOLTIP.SHOW_FAVORITE_FILTERS' | translate"
                    [value]="FilterEngineMode.FAVORITE"
                    matTooltipClass="regular-tooltip"
                  >
                    <mat-icon style="font-size: 22px">star_outlined</mat-icon>
                  </mat-button-toggle>
                  <mat-button-toggle
                    [matTooltip]="'IOT_TOOLBAR.TOOLTIP.SHOW_EXPANDED_FILTERS' | translate"
                    [value]="FilterEngineMode.CLASSIC"
                    matTooltipClass="regular-tooltip"
                  >
                    <mat-icon [svgIcon]="'classic_filter_engine'"></mat-icon>
                  </mat-button-toggle>
                </mat-button-toggle-group>
              </div>

              @if (filterMode() === FilterEngineMode.FAVORITE && displayManageFavoriteFilters()) {
                <div class="iot-platform-ui-filter-engine__settings-button" fxLayout="row" fxLayoutAlign="start center">
                  <span class="iot-platform-ui-filter-engine__right-separator"></span>
                  <button
                    [matTooltip]="'FILTER_ENGINE.MANAGE_FAVORITE_FILTERS.BUTTON_TOOLTIP' | translate"
                    class="regular-round-button"
                    mat-icon-button
                    matTooltipClass="regular-tooltip"
                    (click)="openManageFavoriteFilters()"
                  >
                    <mat-icon>settings</mat-icon>
                  </button>
                  <span class="iot-platform-ui-filter-engine__right-separator"></span>
                </div>
              }
            } @else {
              <mat-icon>filter_list</mat-icon>
            }
          </div>

          <!-- Favorite Mode -->
          @if (filterMode() === FilterEngineMode.FAVORITE) {
            <div class="iot-platform-ui-filter-engine__container" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px">
              @for (field of favoriteFields(); track trackByKey($index, field)) {
                <iot-platform-ui-filter-engine-field-trigger
                  class="mt-1 mb-1"
                  [field]="field"
                  (filterApplied)="onFilterApplied($event)"
                  (selectFavoriteField)="selectFavoriteField($event)"
                />
              }
            </div>
          }

          <!-- Standard Mode -->
          @if (filterMode() === FilterEngineMode.CLASSIC) {
            <div class="iot-platform-ui-filter-engine__container" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px">
              <button [matMenuTriggerFor]="filterCriteria" class="filter-engine-menu mt-1 mb-1" mat-button type="button">
                <span>{{ filterCriteriaButtonTitle() | translate | uppercase }}</span>
                <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
              </button>

              <!-- Cascading Menu -->
              <mat-menu #filterCriteria="matMenu">
                @for (category of categories(); track category.key) {
                  @if (!category?.fields) {
                    <button (click)="handleFieldSelection(category)" mat-menu-item>
                      <span>{{ category.label | translate | uppercase }}</span>
                    </button>
                  } @else {
                    <button [matMenuTriggerFor]="subMenu" mat-menu-item>
                      {{ category.label | translate | uppercase }}
                    </button>

                    <mat-menu #subMenu="matMenu">
                      @for (field of category.fields; track field.key) {
                        <button (click)="handleFieldSelection(field)" mat-menu-item>
                          <span>{{ field.label | translate | uppercase }}</span>
                        </button>
                      }
                    </mat-menu>
                  }
                }
              </mat-menu>

              @if (selectedField()) {
                <iot-platform-ui-filter-engine-field-trigger
                  class="mt-1 mb-1"
                  [field]="selectedField()"
                  (filterApplied)="onFilterApplied($event)"
                  (selectFavoriteField)="selectFavoriteField($event)"
                />
              }
            </div>
          }
        </div>
      </div>
    </mat-expansion-panel>

    <!-- Applied Filters -->
    @if (visibleFiltersCount()) {
      <div
        class="iot-platform-ui-filter-engine__applied-filters pb-3"
        [ngClass]="{ 'pt-4': !expanded(), 'pt-2': expanded() }"
        fxLayout="row wrap"
        fxLayoutAlign="start center"
        fxLayoutGap="5px"
      >
        <div
          [ngClass]="{ 'iot-platform-ui-filter-engine__max-filters-indicator--max': visibleFiltersCount() >= maxSelectedFilters() }"
          class="iot-platform-ui-filter-engine__max-filters-indicator mb-2"
          fxLayout="row"
          fxLayoutAlign="center center"
        >
          @if (visibleFiltersCount() >= maxSelectedFilters()) {
            <mat-icon>warning</mat-icon>
          }
          @if (visibleFiltersCount() > maxSelectedFilters()) {
            <span>{{ visibleFiltersCount() }} > {{ maxSelectedFilters() }}</span>
          } @else {
            <span>{{ visibleFiltersCount() }}/{{ maxSelectedFilters() }}</span>
          }
        </div>

        <!-- Grouped Filters Display -->
        <div class="iot-platform-ui-filter-engine__groups" fxLayout="row wrap" fxLayoutAlign="start center" flexLayoutGap="10px">
          @for (group of groupedFilters(); track group.fieldKey + '_' + group.operator) {
            <div class="iot-platform-ui-filter-engine__group mb-2" fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutAlign="start center" flexLayoutGap="5px">
              <mat-chip-set class="iot-platform-ui-filter-engine__group_chips" fxLayout="row wrap" fxLayoutAlign="start center">
                <div class="iot-platform-ui-filter-engine__group-header" fxLayout="row wrap" fxLayoutAlign="start center" flexLayoutGap="5px">
                  <span class="iot-platform-ui-filter-engine__group_label"> {{ group.fieldLabel | translate }}: </span>

                  @if(expanded()) {
                    @if (!hasBlankOrNotBlankFilter(group.operator)) {
                      <span class="iot-platform-ui-filter-engine__group_operator">
                      {{ 'AG_GRID.' + group.operator | translate }}
                    </span>
                    }
                  } @else {
                    <span class="iot-platform-ui-filter-engine__group_operator">
                      ({{ group?.filters?.length }})
                    </span>
                  }
                </div>

                @if(expanded()) {
                  @if (hasBlankOrNotBlankFilter(group.operator)) {
                    <mat-chip [removable]="true" (removed)="resetFilter(group)" class="iot-platform-ui-filter-engine__group_chip">
                    <span class="iot-platform-ui-filter-engine__group_chip-label">
                      {{ 'AG_GRID.' + group.operator | translate }}
                    </span>
                      <button class="iot-platform-ui-filter-engine__group_chip-remove" matChipRemove>
                        <mat-icon>close</mat-icon>
                      </button>
                    </mat-chip>
                  }

                  @for (item of group?.filters; track item.index) {
                    <mat-chip [removable]="true" (removed)="removeFilter(item.filter)" class="iot-platform-ui-filter-engine__group_chip">
                    <span class="iot-platform-ui-filter-engine__group_chip-label" [matTooltip]="item.filter.valueDisplay ?? item.filter.value | translate">
                      {{ item.filter.valueDisplay ?? item.filter.value | translate }}
                    </span>
                      <button class="iot-platform-ui-filter-engine__group_chip-remove" matChipRemove>
                        <mat-icon>close</mat-icon>
                      </button>
                    </mat-chip>
                  }
                }
              </mat-chip-set>
            </div>
          }
        </div>

        @if (displayActionButtons()) {
          <button (click)="clearAllFilters()" class="iot-platform-ui-filter-engine__clear-all mb-2" color="accent" mat-stroked-button>
            {{ 'FILTER_ENGINE.CLEAR_ALL' | translate }}
          </button>

          @if (displayResetToFavoriteViewFiltersButton()) {
            <button (click)="onResetFavoriteView()" class="iot-platform-ui-filter-engine__reset mb-2" color="accent" mat-stroked-button>
              {{ 'FILTER_ENGINE.RESET' | translate }}
            </button>
          }
        }
      </div>
    }
  </div>
</div>
